const viewHistory = {
    key: 'viewHistory',
    value: "View History",
    icon: "history",
    disabled: false,
    displayBefore: true,
    status: "All"
};

const deleteObj = {
    key: "delete",
    value: "Delete",
    icon: "trash",
    disabled: false,
    displayBefore: true,
    status: ["DRAFT"]
};

const cancel = {
    key: "cancel",
    value: "Cancel Request",
    icon: "cross",
    disabled: false,
    displayBefore: true,
    status: [
        "SUBMITTED",
        "UAT_SETUP",
        "GROUP_TESTING",
        "CTSU_TESTING",
        "PENDING_SIGNOFF",
        "IN_PROGRESS",
        "ADDITIONAL_SIGNOFF"
    ]
};

const addRequest = {
    key: "addRequest",
    value: "Request",
    icon: "plus",
    disabled: false,
    displayBefore: true,
    status: "All"
};

const submit = {
    key: "submit",
    value: "Submit Request",
    icon: "submit",
    disabled: false,
    displayBefore: true,
    status: ["DRAFT"]
};

const viewRegulatory = {
    key: "viewRegulatory",
    value: "View Regulatory",
    icon: "clone",
    disabled: false,
    displayBefore: false,
    status: ["SUBMITTED", "UAT_SETUP", "GROUP_TESTING", "CTSU_TESTING", "PENDING_SIGNOFF", "IN_PROGRESS"]
};

export const buttonObj = [viewHistory, deleteObj, cancel, addRequest, submit, viewRegulatory];